import React, { useState, useEffect } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Title } from 'react-admin';

import App from '../../../../app.js';


export default () => {

	const theapp = App.getAppObject();

	const [versioninfo, setVersionInfo] = useState({});
	const [modulesinfo, setModulesInfo] = useState([]);
	const [nodeinfo, setNodeInfo] = useState({});
	const [devinfo, setDevInfo] = useState([]);

	const fetchInfo = async () => {
		const mvcmydashboard = theapp.getMvcMyDashboardObject();

		let sessionuuid = await mvcmydashboard.getCurrentSession();

		let info = await mvcmydashboard.getNodeInfo(sessionuuid);

		let nodeinfo = {};

		nodeinfo.web3providerUrl = info.web3providerUrl;
		nodeinfo.islistening = (info.islistening ? mvcmydashboard.t('true') : mvcmydashboard.t('false'));
		nodeinfo.chainid = info.chainid;
		nodeinfo.networkid = info.networkid;
		nodeinfo.peercount = info.peercount;
		nodeinfo.issyncing = (info.issyncing ? mvcmydashboard.t('true') : mvcmydashboard.t('false'));
		nodeinfo.currentblock = info.currentblock;
		nodeinfo.highestblock = info.highestblock;

		setNodeInfo(nodeinfo);

		// dev
		if (theapp.exec_env == 'dev') {
			let session_scheme = await mvcmydashboard.getSessionScheme(sessionuuid);
			let ethnode_version = await mvcmydashboard.getEthNodeVersion(sessionuuid);

			let dev_info = [];

			dev_info.push({key: 'scheme_name', label: 'scheme name', value: session_scheme.name})
			dev_info.push({key: 'ethnode_version', label: 'ethnode version', value: (ethnode_version ? ethnode_version : 'direct')})

			setDevInfo(dev_info);
		}
	};


	useEffect(() => {
		const mvcmydashboard = theapp.getMvcMyDashboardObject();

		let webapp_name = theapp.base_name;
		let app_version = theapp.current_version;

		let mvcmodule_version = mvcmydashboard.current_version;
		let api_version = mvcmydashboard.getAPIVersion();
		
		// version
		let versioninfo = {};
		versioninfo.webapp = webapp_name;
		versioninfo.app_ver = app_version;
		versioninfo.mvc_ver = mvcmodule_version;
		versioninfo.api_ver = api_version;

		setVersionInfo(versioninfo);

		if (theapp.exec_env == 'dev') {
			// modules
			let moduleversioninfos = mvcmydashboard.getModulesVersions();
			let modulesinfo = [];

			for (var i = 0; i < moduleversioninfos.length; i++) {
				modulesinfo.push({key: i+1, label: moduleversioninfos[i].name, value: moduleversioninfos[i].version})
			}
			
			setModulesInfo(modulesinfo);
		}

		// node info
		let nodeinfo = {};
		nodeinfo.web3providerUrl = mvcmydashboard.t('loading');
		nodeinfo.islistening = mvcmydashboard.t('loading');
		nodeinfo.chainid = mvcmydashboard.t('loading');
		nodeinfo.networkid = mvcmydashboard.t('loading');
		nodeinfo.peercount = mvcmydashboard.t('loading');
		nodeinfo.issyncing = mvcmydashboard.t('loading');
		nodeinfo.currentblock = mvcmydashboard.t('loading');
		nodeinfo.highestblock = mvcmydashboard.t('loading');

		setNodeInfo(nodeinfo);

		// fetch async info
		fetchInfo().catch(err => {});

		return () => {
		};
	}, []);
	return (
		<Card>
			<Title title="About My Dashboard" />
			<CardContent>
			<div className="Container">
				<div className="TextBox">
					<h3>Version Info</h3>
					<table>
						<tbody>
						<tr><td><span>web app:</span></td><td>{versioninfo.webapp}</td></tr>
						<tr><td><span>app:</span></td><td>{versioninfo.app_ver}</td></tr>
						<tr><td><span>mvc:</span></td><td>{versioninfo.mvc_ver}</td></tr>
						<tr><td><span>api:</span></td><td>{versioninfo.api_ver}</td></tr>
						<tr><td><span>&nbsp;</span></td><td>&nbsp;</td></tr>
						{modulesinfo.map(function(moduleinfo) {
							return <tr key={moduleinfo.key}><td><span>{moduleinfo.label}</span></td><td>{moduleinfo.value}</td></tr>;
						})}
						</tbody>
					</table>
					<h3>Node Info</h3>
					<table>
						<tbody>
						<tr><td><span>web3 provider:</span></td><td>{nodeinfo.web3providerUrl}</td></tr>
						<tr><td><span>listening:</span></td><td>{nodeinfo.islistening}</td></tr>
						<tr><td><span>chain id:</span></td><td>{nodeinfo.chainid}</td></tr>
						<tr><td><span>network id:</span></td><td>{nodeinfo.networkid}</td></tr>
						<tr><td><span>peer count:</span></td><td>{nodeinfo.peercount}</td></tr>
						<tr><td><span>syncing:</span></td><td>{nodeinfo.issyncing}</td></tr>
						<tr><td><span>current block:</span></td><td>{nodeinfo.currentblock}</td></tr>
						<tr><td><span>highest block:</span></td><td>{nodeinfo.highestblock}</td></tr>
						</tbody>
						<tr><td><span>&nbsp;</span></td><td>&nbsp;</td></tr>
						{devinfo.map(function(line) {
							return <tr key={line.key}><td><span>{line.label}</span></td><td>{line.value}</td></tr>;
						})}
					</table>

				</div>
			</div>
			</CardContent>
		</Card>
	);
};